import { render, staticRenderFns } from "./ADAuthForm.vue?vue&type=template&id=966fc586&"
import script from "./ADAuthForm.vue?vue&type=script&lang=js&"
export * from "./ADAuthForm.vue?vue&type=script&lang=js&"
import style0 from "./ADAuthForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports